<template>
  <div class="cause-component">
    <template v-if="$store.state.showGoogleMap">
      <div v-show="!isSingeCause">
        <GoogleMap
          :causes="posts"
          :miles="miles"
          @showGoogleMapHandler="showGoogleMapHandler"
          @show-cause-detail="showCauseSingle"
          @update-list="clearPosts"
        ></GoogleMap>
      </div>
    </template>

    <template v-if="$store.state.showAppFilters">
      <AppFilter
        :mile="miles"
        :filter-category="filterCategory"
        :cause="postSingle"
        :open-now-section="openNow"
        :search-title="searchTitle"
        :search-type="postType"
        :lbp="locationByPricing"
        :perk="discountFilter"
        @changeFilterData="changeFilterData"
        @search-by-title="SearchByTitle"
      >
      </AppFilter>
    </template>
    <div v-if="!isHeader" :class="[paddingForHeading]">
      <Top
        v-model="searchTitle"
        :is-partner="isPartner"
        :is-signup="isPathLogin"
        @show-cause-filter="showCauseFilter"
        @map-filter-handler="mapFilterHandler"
        @show-google-map-handler="showGoogleMapHandler"
      />
    </div>
    <div
      v-if="isLocationSection"
      class="current-location-section bg-white relative z-10 px-8 py-6"
    >
      <CurrentLocation through="locations" />
    </div>
    <div
      class="bg-white relative z-10 cause-list-container pt30"
      v-if="!$store.state.showAppFilters"
    >
      <div class="pl-8 overflow-hidden">
        <CategoryFilter
          v-if="!$store.state.showGoogleMap"
          :post-type="postType"
          :filter-causes="filterCauses"
        >
        </CategoryFilter>
      </div>
      <template v-if="hasPost">
        <div
          class="text-right px30"
          v-if="$store.state.showGoogleMap && postType === 'partner'"
        >
          <button
            v-ripple
            class="sort-btn text-14 font-bold text-text text-center mb-4"
            type="button"
            @click="showSortBy = true"
          >
            {{ $t("Sort") }}
          </button>
        </div>
        <div
          class="cause-list min-h-230 pt-4 px30"
        >
          <PostItem
            v-for="item in posts"
            :cause="item"
            :key="`post-${item.id}`"
            :is-select="true"
            :is-single="false"
            :post-type="postType"
            :click-handler="() => showCauseSingle(item)"
          ></PostItem>
          <InfiniteLoading 
            :call="fetchPosts"  
            :infiniteId="infiniteId"
          />
          <Suggest v-if="!isPathLogin" :is-partner="isPartner" />
          <SortBy v-if="showSortBy" @closeSortBy="closeSortBy" :sort-by="sortBy" />
        </div>
      </template>
      <div v-else class="flex flex-grow items-center justify-center">
        <div class="text-center text-14 text-light_grey py-4">
          <div class="table mx-auto">
            <BigSearch />
          </div>

          <p class="mt-6">{{ $t("Sorry") }}</p>
          <p>{{ $t("No Results Found") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "../UI/InfiniteLoading.vue";
import Toggle from "../Icons/Toggle";
import GoogleMap from "../GoogleMap/GoogleMap";
import AppFilter from "../Filters/AppFilter";
import MapIcon from "../Icons/MapIcon";
import BigSearch from "../Icons/BigSearch";
import CategoryFilter from "../Filters/TagFilter";
import PostItem from "./PostItem";
import SettingsIcon from "../Icons/SettingsIcon";
import SortBy from "../Filters/SortBy";
import Top from "./Top.vue";
import CurrentLocation from "../Location/CurrentLocation.vue";
import Suggest from "./Suggest.vue";
import mixins from "../../config/mixins";
export default {
  name: "Post",
  mixins: [mixins.location, mixins.retailers, mixins.npos],
  components: {
    SortBy,
    SettingsIcon,
    PostItem,
    CategoryFilter,
    BigSearch,
    InfiniteLoading,
    MapIcon,
    Toggle,
    GoogleMap,
    AppFilter,
    Top,
    CurrentLocation,
    Suggest
  },

  props: ["postType", "appTitle"],

  data: function() {
    return {
      posts: [],
      loadPosts: [],
      total: 0,
      tags: [],
      miles: 0,
      filterCategory: [],
      typeFilter: "map",
      postSingle: {},
      page: 0,
      npoPage: 0,
      pages: 1,
      limit: 10,
      currentPage: 0,
      searchTitle: "",
      locale: this.$i18n.locale,
      urls: {
        tags: "",
        posts: ""
      },
      postLoad: false,
      openNow: false,
      locationByPricing: 0,
      discountFilter: 0,
      sortBy: "",
      showSortBy: false,
      hasPost: false,
      noMorePosts: "No more organizations",
      infiniteId: +new Date()
    };
  },

  watch: {
    "$store.state.userLocation": function() {
      this.clearPosts();
    }
  },

  async mounted() {
    this.getLocation();
    await this.findPrimaryLocation();
    switch (this.postType) {
      case "cause":
        this.noMorePosts = "No more organizations";
        this.urls = {
          tags: "npos/listtags",
          posts: "npos/list"
        };
        break;
      case "partner":
        this.noMorePosts = "No more locations";
        this.urls = {
          tags: "retailer/listtags",
          posts: "retailer/list"
        };
        break;
      default:
        this.noMorePosts = "No more organizations";
        this.urls = {
          tags: "",
          posts: ""
        };
    }
    this.getTags();
    this.clearPosts();
  },
  computed: {
    isPartner() {
      return this.postType == "partner";
    },
    isPathLogin() {
      return this.$route.path == "/login";
    },
    paddingForHeading() {
      if (this.$getState("loginActiveStep") == "cause") {
        return "top px30";
      }
      if (!this.isPathLogin) {
        return this.isPartner ? "top" : "top px30";
      } else {
        return "";
      }
    },
    paddingForList() {
      return !this.isPathLogin && (this.isPartner || this.postType == "cause");
    },
    corporationTitle: function() {
      const corpData = this.$getState("corporation");
      if (!!corpData.title && corpData.title.length) {
        return this.getLocalizationData(corpData.title);
      }
      return "Thrive";
    },
    isSingeCause() {
      const types = ["causeSingle", "partnerSingle"];
      return types.includes(this.$store.state.typeAppFilter);
    },
    isHeader() {
      return (
        this.$store.state.showGoogleMap || this.$store.state.showAppFilters
      );
    },
    isLocationSection() {
      return this.isPartner && !this.isHeader;
    }
  },

  methods: {
    clearPosts () {
      this.hasPost = 1;
      this.page = 0;
      this.npoPage = 0
      this.posts = [];
      this.infiniteId += 1;
    },
    closeSortBy (sortBy) {
      this.sortBy = sortBy;
      this.showSortBy = false;
      if (sortBy) {
        this.clearPosts();
      }
    },
    mapFilterHandler () {
      // On Signup the step functionality not working for bank step.
      this.$setState("showAppFilters", true);
      this.$setState("isNavigation", false);
      this.$setState("filterWithoutMap", true);
    },
    getPostsArguments () {
      const coords = this.$getState("userLocation");

      const args = {
        offset: this.isPartner ?  this.page * this.limit : this.npoPage * this.limit,
        search: this.searchTitle,
        tag: this.tagActive,
        category: this.filterCategory,
        sort_by: this.sortBy,
        limit: this.limit
      };

      if (this.openNow) {
        args.open_now = this.openNow;
      }
      if (this.locationByPricing) {
        args.location_by_pricing = this.locationByPricing;
      }
      if (this.discountFilter) {
        args.discountFilter = this.discountFilter;
      }

      if (this.miles && this.miles > 0 && coords.lat && coords.lng) {
        args.location = {
          center_lat: coords.lat,
          center_lng: coords.lng,
          dist: this.miles
        };
      }

      return args;
    },
    async getNpos (args, $state) {
      const  res = await this.$http.post('npos/list', args)
      if (!res.status) return;
      const length = res.data.npo && res.data.npo.length
      if (length) { 
        this.npoPage += 1;
        this.posts.push(...res.data.npo)
        this.posts = this.posts.filter(p => JSON.parse(p.title)['en'])
        $state.loaded();
        return
      }
      $state.complete()
    },
    async fetchPosts ($state) {
      const args = this.getPostsArguments();
      if(!this.isPartner) {
        this.getNpos(args, $state)
        return
      }
      this.retailersInFiftyMiles(args, this.savePosts, $state)
      
    },
    savePosts (data, $state) {
      if (data.length) { 
        this.posts.push(...data);
        this.page += 1;
        $state.loaded();
        return
      }
      $state.complete()
    },
    showCauseSingle (item) {
      const type = this.isPartner ? "partnerSingle" : "causeSingle";
      this.postSingle = item;
      this.$setState("typeAppFilter", type);
      this.$setState("showAppFilters", true);
      this.$setState("isNavigation", false);
    },
    changeFilterData: function(
      miles,
      category,
      openNow,
      locationByPricing,
      discountFilter
    ) {
      this.miles = miles;
      this.filterCategory = category;
      this.openNow = openNow;
      this.locationByPricing = locationByPricing;
      this.discountFilter = discountFilter;
      if (!this.$getState("filterWithoutMap")) {
        this.$setState("showGoogleMap", true);
      } else {
        this.$setState("isNavigation", true);
        this.$scrollToTop();
      }
      this.$setState("filterWithoutMap", false);
      this.$setState("showAppFilters", false);
      this.clearPosts();
    },
    showGoogleMapHandler () {
      this.$setState("showGoogleMap", !this.$getState("showGoogleMap"));

      if (this.$route.path === "/login") {
        this.$setState("showSteps", !this.$store.state.showSteps);
      } else {
        this.$setState("isNavigation", !this.$getState("isNavigation"));
      }
      this.clearPosts();
    },
    showCauseFilter () {  
      this.$setState("typeAppFilter", "cause");
      this.$setState("showAppFilters", true);
      this.$setState("isNavigation", false);
    },
    filterCauses (id) {
      this.filterCategory = [];
      id && this.filterCategory.push(id);
      this.clearPosts();
    },
    async getTags () {
      const { status, data } = await this.$http.post(this.urls.tags)
      if(status) {
        this.tags = data.tags || []
      }
    },
    SearchByTitle (title) {
      this.searchTitle = title;
      this.clearPosts()
    }
  },
  watch: {
    "$store.state.showAppFilters": {
      immediate: true,
      deep: true,
      handler(flag) {
        if (!flag) this.postSingle = {};
      }
    }
  }
};
</script>
